import React from 'react';

interface ErrorFallbackProps {
  error: Error;
  info: React.ErrorInfo;
  clearError: () => void;
}

export default function ErrorFallback({ error, clearError }: ErrorFallbackProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-semibold">Something went wrong.</h1>
      <p className="max-w-xl text-sm text-muted-foreground">{error.message}</p>
      <button
        type="button"
        onClick={clearError}
        className="rounded-md border border-input bg-background px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground"
      >
        Try again
      </button>
    </div>
  );
}
